import * as React from 'react'
import { PoweredByToastModal } from '../../../../client/components/PoweredByToastModal/PoweredByToastModal'
import { SmsConfirmation } from '@local/do-secundo-sms-confirmation-component'
import { useHistory, useLocation } from 'react-router-dom'
import {
  CodeConfirmationForm,
  CodeConfirmationFormProps
} from '@local/do-secundo-code-confirmation'
import {
  useIsAccountLinkingEnabled,
  hasPasswordlessAccount,
  FROM_LOCATION
} from '@local/do-secundo-passwordless-authentication'
import { ModeLink } from '../../../../client/components/ModeRouter/utils'

export interface SmsVerificationModalProps extends CodeConfirmationFormProps {
  onClose?: () => void
  handleResend: () => void
  phone: string
  header?: React.ReactNode
  mainText?: React.ReactNode
}

export const SmsVerificationModal = ({
  onClose = () => {},
  handleSubmit,
  numFields,
  handleResend,
  phone,
  header,
  mainText
}: SmsVerificationModalProps) => {
  const history = useHistory()
  const { state } = useLocation<{ from: FROM_LOCATION }>()
  const ACCOUNT_LINKING_ENABLED = useIsAccountLinkingEnabled()
  const dataIdSuffix = state?.from === FROM_LOCATION.login ? 'login' : 'create'

  return (
    <div className={'text-center'} data-testid={'sms-verification-modal'}>
      <PoweredByToastModal onClose={onClose} header={header}>
        {mainText}
        <SmsConfirmation
          form={
            <CodeConfirmationForm
              testId={`code-confirmation-form-${dataIdSuffix}`}
              numFields={numFields}
              handleSubmit={handleSubmit}
              idPrefix={'modal'}
            />
          }
          handleResend={handleResend}
          testId={`sms-confirmation-modal-${dataIdSuffix}`}
        />
        {state?.from === FROM_LOCATION.login && !hasPasswordlessAccount() && (
          <div className={'pt-4 text-center'}>
            <p>Having trouble logging in? </p>
            <span
              onClick={() => {
                if (ACCOUNT_LINKING_ENABLED) {
                  history.push('?mode=connectLogin', {
                    accountLinkingEnabled: ACCOUNT_LINKING_ENABLED,
                    phone
                  })
                } else {
                  // this mirrors what we're doing in LoginPasswordlessModal
                  // it exists for the scenario that when we're not doing account linking
                  // we need to add the auth key to localStorage to switch to a legacy experience.
                  window.localStorage.setItem('auth', JSON.stringify({}))
                }
              }}
            >
              <ModeLink
                data-testid='sms-modal-passwordless-legacy-login'
                style='primary'
                mode='login'
              >
                Log in with email and password
              </ModeLink>
            </span>
            <p>or</p>
            <ModeLink
              data-testid='sms-modal-create-account-link-secondary'
              style='primary'
              mode='create'
            >
              Create an account
            </ModeLink>
          </div>
        )}
        {state?.from === FROM_LOCATION.login && hasPasswordlessAccount() && (
          <div className={'pt-4 text-center'}>
            Having trouble logging in?{' '}
            <ModeLink
              data-testid='sms-modal-create-account-link'
              style='primary'
              mode='create'
            >
              Create account
            </ModeLink>
          </div>
        )}
      </PoweredByToastModal>
    </div>
  )
}
